import {h, Component} from 'preact';
import invoke from 'lodash.invoke';
import equal from 'deep-equal';
import cx from 'classnames';

/**
 * SearchResultItem -> wrapper component to display current selected index mouse and keyboard interactions
 * @param active
 * @param children
 * @return {*}
 * @constructor
 */
class SearchResultItem extends Component {

    shouldComponentUpdate ( nextProps ) {
        return !equal( nextProps, this.props );
    }

    handleMouseEnter = evt => {
        invoke( this.props, 'onResultHover', evt, this.props )
    };

    handleClick = evt => {
        invoke( this.props, 'onResultClick', evt, this.props )
    };

    render () {
        const {index, active, activeClass = '', children, ...rest} = this.props;
        const itemClasses = cx(
            't-transform t-duration-short',
            {[activeClass]: active}
        );

        return (
            <div id={`search-result-item-${index}`}
                 data-testid="search-result-item"
                 onMouseEnter={this.handleMouseEnter}
                 onClick={this.handleClick}
                 className={itemClasses}
                 {...rest}>
                {children}
            </div>
        );
    }
}

export default SearchResultItem;
